import React, { Component } from 'react';

import PaginationComponent from '../components/PaginationComponent';
import ModalPurchase from '../components/ModalPurchase';
import { SHIPPING_STATUS } from '../utils/enums';
import { sortClass, nextSortDir, sortAriaSort } from '../utils/table';
import { getTextColorClassShipping } from '../utils/formats';
import { getProviders } from '../utils/functions';
import { buildPaginationQuery, getPaginatedData, scheduleDebouncedCallback, clearDebouncedCallback } from '../utils/pagination';
import { hasActiveSearch, getSearchEmptyMessage } from '../utils/tableState';

var config = process.env;

class TableShippingComponent extends Component {

    constructor() {
        super();
        this.state = {
            purchaseId: 0,
            quantityShowRows: 25,
            currentPage: 1,
            totalItems: 0,
            search: '',
            searchInput: '',
            sortBy: 'shippingId',
            sortDir: 'desc',
            data: [],
            loaded: false,
            providers: []
        };
    }

    async componentDidMount() {
        this.fetchData();
        let providers = await getProviders('shipping');
        this.setState({ providers });
    }

    componentWillUnmount() {
        clearDebouncedCallback(this, 'searchDebounceTimeout');
    }

    fetchData = ({
        page = this.state.currentPage,
        limit = this.state.quantityShowRows,
        search = this.state.search,
        sortBy = this.state.sortBy,
        sortDir = this.state.sortDir,
        showLoader = true,
    } = {}) => {
        if (showLoader) {
            this.setState({ loaded: false });
        }
        var request = {
            method: 'GET',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            }
        };
        const query = buildPaginationQuery({ page, limit, search, sortBy, sortDir });
        fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}shipping?${query}`, request)
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                const paginatedData = getPaginatedData(data);
                this.setState({
                    data: paginatedData.items || [],
                    quantityShowRows: paginatedData.limit || Number(limit),
                    currentPage: paginatedData.page || Number(page),
                    totalItems: paginatedData.total || 0,
                    search,
                    sortBy,
                    sortDir,
                    loaded: true
                });
            }
        });
    }

    renderEmptyState = () => {
        return (
            <div
                style={{
                    background: '#ffffff',
                    borderRadius: '0.625rem',
                    boxShadow: '0 .125rem .625rem rgba(90,97,105,.12)',
                    border: '1px solid #e1e5eb',
                    minHeight: '320px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                }}
            >
                <div style={{ textAlign: 'center', maxWidth: '420px' }}>
                    <div
                        style={{
                            width: '72px',
                            height: '72px',
                            margin: '0 auto 1rem',
                            borderRadius: '50%',
                            background: '#f5f6f8',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <i className="material-icons" style={{ fontSize: '34px', color: '#818ea3' }}>local_shipping</i>
                    </div>
                    <h4 style={{ marginBottom: '0.75rem', color: '#3d5170', fontWeight: 500 }}>
                        Todavia no hay envios para mostrar
                    </h4>
                    <p style={{ margin: 0, color: '#818ea3', lineHeight: 1.6 }}>
                        Cuando existan envios registrados, aca vas a ver su estado, direccion,
                        proveedor y accesos de gestion.
                    </p>
                </div>
            </div>
        );
    }

    renderLoader = () => {
        return (
            <div
                style={{
                    background: '#ffffff',
                    borderRadius: '0.625rem',
                    boxShadow: '0 .125rem .625rem rgba(90,97,105,.12)',
                    border: '1px solid #e1e5eb',
                    minHeight: '320px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2rem',
                }}
            >
                <div className="containerLoader" style={{ display: 'block', position: 'static', width: '100%' }}>
                    <div className="loader"></div>
                </div>
            </div>
        );
    }

    loadData = () => {
        if (!this.state.loaded) {
            return <tbody></tbody>;
        }

        const items = this.state.data.map((item, index) => this.drawRow(item, index));
        if (items.length === 0) {
            items.push(
                <tr key="empty">
                    <td colSpan="7" style={{ textAlign: 'center', padding: '10px', border: '1px solid rgb(225, 229, 235)' }}>
                        {getSearchEmptyMessage(this.state.searchInput || this.state.search)}
                    </td>
                </tr>
            );
        }
        return <tbody>{items}</tbody>;
    }

    createModals = () => {
        if (!this.state.loaded) {
            return null;
        }
        return (
            <div>
                {this.state.data.map((data) => this.createModalChangeTrack(data.shippingId, data.status, data.provider, data.cost))}
            </div>
        );
    }

    getItemsShipping = (currentStatus) => {
        let items = [];
        if (currentStatus == 4) {
            items.push(<option value="4" key="4">{SHIPPING_STATUS[4]}</option>);
            items.push(<option value="8" key="8">{SHIPPING_STATUS[8]}</option>);
        } else if (currentStatus == 6) {
            items.push(<option value="6" key="6">{SHIPPING_STATUS[6]}</option>);
            items.push(<option value="5" key="5">{SHIPPING_STATUS[5]}</option>);
        }
        return items;
    }

    getItemsProviders = () => {
        return this.state.providers.map((provider) => (
            <option value={provider.providerId} key={provider.providerId}>{provider.name}</option>
        ));
    }

    createModalChangeTrack = (shippingId, currentStatus, currentProvider, currentCost) => {
        return (
            <div className="modal fade" id={`modal-${shippingId}`} role="dialog" key={shippingId}>
                <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '540px' }}>
                    <div className="modal-content" style={{ borderRadius: '0.9rem', overflow: 'hidden' }}>
                        <div className="modal-header" style={{ padding: '1.1rem 1.5rem 1rem' }}>
                            <h4 className="modal-title mb-0" style={{ color: '#3d5170' }}>Cambiar estado de envío</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body" style={{ padding: '1.25rem 1.5rem 1.1rem' }}>
                            <div className="form-group mb-3">
                                <label htmlFor={`status-${shippingId}`} style={{ fontWeight: 600, color: '#5a6169', marginBottom: '0.45rem' }}>
                                    Estado
                                </label>
                                <select id={`status-${shippingId}`} className="custom-select" defaultValue={currentStatus}>
                                    {this.getItemsShipping(currentStatus)}
                                </select>
                            </div>
                            <div className="form-group mb-3">
                                <label htmlFor={`provider-${shippingId}`} style={{ fontWeight: 600, color: '#5a6169', marginBottom: '0.45rem' }}>
                                    Provider
                                </label>
                                <select id={`provider-${shippingId}`} className="custom-select" defaultValue={currentProvider}>
                                    {this.getItemsProviders()}
                                </select>
                            </div>
                            <div className="form-group mb-0">
                                <label htmlFor={`cost-${shippingId}`} style={{ fontWeight: 600, color: '#5a6169', marginBottom: '0.45rem' }}>
                                    Costo de envío
                                </label>
                                <input type="text" className="form-control" id={`cost-${shippingId}`} defaultValue={currentCost}/>
                            </div>
                        </div>
                        <div className="modal-footer" style={{ padding: '0.9rem 1.5rem 1.25rem', gap: '0.5rem' }}>
                            <button
                                className="btn btn-outline-secondary btn-sm"
                                data-dismiss="modal">
                                Cancelar
                            </button>
                            <button
                                className="btn btn-primary btn-sm"
                                data-dismiss="modal"
                                onClick={() => this.onUpdateItem(shippingId)}>
                                Actualizar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    onUpdateItem = (shippingId) => {
        var value = document.getElementById('status-' + shippingId).value;
        var provider = document.getElementById('provider-' + shippingId).value;
        var cost = document.getElementById('cost-' + shippingId).value;
        var request = {
            method: 'PATCH',
            headers: {
                'access-token': localStorage.getItem('token'),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                shippingId: parseInt(shippingId),
                status: parseInt(value),
                provider: parseInt(provider),
                cost: parseInt(cost)
            })
        };
        fetch(config.REACT_APP_BASE_URL + config.REACT_APP_VERSION + 'shipping/', request)
        .then(results => results.json())
        .then(data => {
            if (data.error > 0) {
                alert(data.message);
                if (data.error == 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
            } else {
                this.fetchData();
            }
        });
    }

    onTicketClicked = (purchaseId) => {
        this.setState({ purchaseId: purchaseId });
    }

    drawRow = (item, index) => {
        return (
            <tr role="row" className="odd" key={item.shippingId} style={{ background: index % 2 == 0 ? '#ffffff;' : '#fcfcfc' }}>
                <td tabIndex="0" className="sorting_1">{item.shippingId}</td>
                <td id={`item-status-${item.shippingId}`} className={getTextColorClassShipping(item.status)}>{SHIPPING_STATUS[item.status]}</td>
                <td data-toggle="modal" data-target="#modal-view" onClick={() => this.onTicketClicked(item.purchaseId)}><a href="#!" onClick={(event) => event.preventDefault()}> {item.purchaseId} </a></td>
                <td>{item.address}</td>
                <td>{item.hourPrefference}</td>
                <td id={`item-provider-${item.shippingId}`}>{item.providerName}</td>
                <td>
                    <div className="btn-group btn-group-sm" role="group" aria-label="Table row actions">
                        <button
                            id={`button-status-${item.shippingId}`}
                            data-toggle="modal"
                            data-target={`#modal-${item.shippingId}`}
                            type="button"
                            disabled={item.status == 5 || item.status == 8 || item.status == 9}
                            className="btn btn-white"><i className="material-icons">edit</i>
                        </button>
                    </div>
                </td>
            </tr>
        );
    }

    onChangeShowRows = () => {
        const itemSelected = Number(document.getElementById('select_rows').value);
        this.fetchData({ page: 1, limit: itemSelected });
    }

    onChangeInput = (search) => {
        this.setState({ searchInput: search });
        scheduleDebouncedCallback(this, 'searchDebounceTimeout', () => {
            this.fetchData({ page: 1, search, showLoader: false });
        });
    }

    orderData = (column) => {
        this.fetchData({
            page: 1,
            sortBy: column,
            sortDir: nextSortDir(column, this.state.sortBy, this.state.sortDir),
        });
    }

    // Props de una cabecera ordenable: la clase y el aria-sort se derivan del state, así que
    // sobreviven al remonte que provoca el loader.
    sortableHeader = (column) => ({
        onClick: () => this.orderData(column),
        className: sortClass(column, this.state.sortBy, this.state.sortDir),
        'aria-sort': sortAriaSort(column, this.state.sortBy, this.state.sortDir),
        tabIndex: '0',
    })

    render() {
        if (!this.state.loaded) {
            return (
                <div>
                    {this.renderLoader()}
                    {this.createModals()}
                    <ModalPurchase purchaseId={this.state.purchaseId} onRefresh={this.fetchData}/>
                </div>
            );
        }

        if (this.state.totalItems === 0 && !hasActiveSearch(this.state.searchInput, this.state.search)) {
            return (
                <div>
                    {this.renderEmptyState()}
                    {this.createModals()}
                    <ModalPurchase purchaseId={this.state.purchaseId} onRefresh={this.fetchData}/>
                </div>
            );
        }

        return (
            <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                <div className="dataTables_length" id="DataTables_Table_0_length">
                    <label>Show
                    <select id="select_rows" name="DataTables_Table_0_length" aria-controls="DataTables_Table_0" value={this.state.quantityShowRows} onChange={() => this.onChangeShowRows()}>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    entries</label>
                </div>
                <div id="DataTables_Table_0_filter" className="dataTables_filter">
                    <label>Search:
                    <input id="input_search" type="search" className="" placeholder="" aria-controls="DataTables_Table_0" value={this.state.searchInput} onChange={(e) => this.onChangeInput(e.target.value)}/>
                    </label>
                </div>

                <table className="transaction-history d-none dataTable no-footer dtr-inline" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                    <thead>
                        <tr role="row">
                            <th {...this.sortableHeader('shippingId')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>ID</th>
                            <th {...this.sortableHeader('status')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Estado</th>
                            <th {...this.sortableHeader('purchaseId')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Compra</th>
                            <th {...this.sortableHeader('address')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '25%' }}>Dirección</th>
                            <th {...this.sortableHeader('hourPrefference')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Preferencia horaria</th>
                            <th {...this.sortableHeader('providerName')} aria-controls="DataTables_Table_0" rowSpan="1" colSpan="1" style={{ width: '15%' }}>Proveedor</th>
                            <th rowSpan="1" colSpan="1" style={{ width: '10%' }}>Acciones</th>
                        </tr>
                    </thead>
                    {this.loadData()}
                </table>

                {this.createModals()}

                <ModalPurchase purchaseId={this.state.purchaseId} onRefresh={this.fetchData}/>

                <PaginationComponent
                    totalItems={this.state.totalItems}
                    quantityRows={this.state.quantityShowRows}
                    currentPage={this.state.currentPage}
                    onPageChange={(page) => this.fetchData({ page })}
                />
            </div>
        );
    }
}

export default TableShippingComponent;
